import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";

const AdminLogin = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const home = "/admin";

    useEffect(() => {
        let m = document.querySelector('meta[name="robots"]');
        if (!m) {
            m = document.createElement("meta");
            m.setAttribute("name", "robots");
            document.head.appendChild(m);
        }
        m.setAttribute("content", "noindex,nofollow");
        if (localStorage.getItem("luxati_token")) navigate(home);
    }, []);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            const { data } = await api.post("/auth/login", { email, password });
            localStorage.setItem("luxati_token", data.token);
            navigate(home);
        } catch (err) {
            setError(formatApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <main data-testid="admin-login-page" className="flex min-h-screen items-center justify-center bg-[#F1F5F9] px-6">
            <form
                data-testid="admin-login-form"
                onSubmit={submit}
                className="w-full max-w-sm border border-slate-200 bg-white p-10 shadow-sm"
            >
                <p className="font-serif text-2xl font-medium tracking-[0.22em] text-ink">LUXATI</p>
                <p className="mt-1 text-[10px] uppercase tracking-[0.3em] text-slate-400">Admin Access</p>
                <div className="mt-8 space-y-5">
                    <div>
                        <label className="text-xs font-medium text-slate-600">Email</label>
                        <input
                            data-testid="admin-email-input"
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="mt-1 w-full border border-slate-300 px-3 py-2.5 text-sm focus:border-ink focus:outline-none"
                        />
                    </div>
                    <div>
                        <label className="text-xs font-medium text-slate-600">Password</label>
                        <input
                            data-testid="admin-password-input"
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="mt-1 w-full border border-slate-300 px-3 py-2.5 text-sm focus:border-ink focus:outline-none"
                        />
                    </div>
                    {error && (
                        <p data-testid="admin-login-error" className="text-xs text-red-600">{error}</p>
                    )}
                    <button
                        data-testid="admin-login-submit"
                        type="submit"
                        disabled={loading}
                        className="w-full bg-ink py-3 text-[11px] font-medium uppercase tracking-[0.22em] text-ivory transition-colors duration-300 hover:bg-charcoal disabled:opacity-50"
                    >
                        {loading ? "Signing in…" : "Sign In"}
                    </button>
                </div>
            </form>
        </main>
    );
};

export default AdminLogin;
